module.exports = __webpack_public_path__ + "img/logo_white.433250b.png";